export default {
    'edit-account': 'Edit account',
    'delete-account': 'Delete account',
    "pinned": "Pinned",
    'unpinned': "Unpinned",
    'account-type': {
        title: 'Account type',
        main: 'Main',
        sub: 'Sub',
    },
    
    'account-category': 'Account classification:',
    
    'final-accounts': {
        title: 'Final account',
        operations: 'Operating',
        trade: 'Trading',
        'gains-and-losses': 'Profit and losses',
        budget: 'Balance sheet',
    },

    'max-credit-amount': 'Credit limit',
    'max-debit-amount': 'Debit limit',
    'debt-is-forbidden': 'Banned from debt',
    yes: 'Yes',
    no: 'No',

    'contect-info': {
        'phone-number': 'Phone number',
        'mobile-number': 'Mobile number',
        email: 'Email',
        address: 'Address',
    },
    
    notes: 'Notes',
    
    'account-statement': 'Account statement',
    'breakdown-of-the-total-by-currency': 'Detailes of Total By Currencies',
    
    'delete-the-account': 'Delete account',
    'are-you-sure-you-want-to-delete-the-account-$': 'Are you sure about deleting {accountName} account?',

    headers: {
        'sum-debits': 'Total debit',
        'sum-credits': 'Total credit',
        balance: 'Balance',
        'equivalent-currency': 'Equivalent currency',
        'currency-equivalent': 'Currency equivalent',
        'currencies-balances': 'Currency balance',
    },

    'sum-currencies-result-headers': {
        'currency-debits': 'Foreign currencies debit',
        'currency-credits': 'Foreign currencies credit',
    }
}